export const playButton = (theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  playButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
    background: theme.customPalette.tangerine,
    width: '49px',
    height: '49px',
    borderRadius: '50%',
  },
  playText: {
    marginTop: theme.spacing(2),
    fontWeight: 500,
  },
  playIcon: {
    width: 27,
    height: 27,
    filter:
      'brightness(0) saturate(100%) invert(20%) sepia(53%) saturate(2487%) hue-rotate(271deg) brightness(92%) contrast(92%)',
  },
});
